import { useEffect, useState } from 'react';
import { formatDuration, secondsUntil } from '../lib/format';

export function Timer({ closesAt, status, large = false }: { closesAt: string; status: string; large?: boolean }) {
  const [seconds, setSeconds] = useState(() => secondsUntil(closesAt));

  useEffect(() => {
    setSeconds(secondsUntil(closesAt));
    const id = window.setInterval(() => setSeconds(secondsUntil(closesAt)), 1000);
    return () => window.clearInterval(id);
  }, [closesAt]);

  const isClosed = status !== 'open' || seconds <= 0;

  return (
    <div className={large ? 'timer timer-large' : 'timer'} data-urgent={!isClosed && seconds <= 60}>
      {isClosed ? 'Chiusa' : formatDuration(seconds)}
    </div>
  );
}
